import Vue from 'vue'
import App from './App.vue'
import 'es6-promise/auto'
import Mint from 'mint-ui'
import moment from 'moment'

import router from './router'
import store from './store'
import utils from './util/util'

import 'mint-ui/lib/style.css'
import './assets/style/iconfont/iconfont.css'
import './assets/style/common.scss'
import {
  Image as VanImage, Button, Icon, Form, Field, Cell, CellGroup, Radio, RadioGroup, Checkbox, CheckboxGroup, Uploader,
  Notify, Tab, Tabs, NavBar, Pagination, DropdownMenu, DropdownItem, Search, Dialog, Calendar,
  NoticeBar, Swipe, SwipeItem, Card, Tag, Popover, Toast
} from 'vant'
import 'vant/lib/index.css'
Vue.prototype.$toast = Toast

Vue.use(Mint)
Vue.use(VanImage).use(Button).use(Icon).use(Form).use(Field).use(Cell).use(CellGroup).use(Radio).use(RadioGroup).use(Checkbox)
  .use(CheckboxGroup).use(Uploader).use(Notify).use(Tab).use(Tabs).use(NavBar).use(Pagination).use(DropdownMenu).use(DropdownItem)
  .use(Search).use(Dialog)
  .use(Calendar)
  .use(NoticeBar)
  .use(Swipe)
  .use(SwipeItem)
  .use(Card)
  .use(Tag)
  .use(Popover)


Vue.prototype.utils = utils;

moment.locale('zh-cn')
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.prototype.imgUrl = 'http://siyb.iwdjy.com/'

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
// new Vue({
//     el: '#app',
//     store,
//     router,
//     components: { App },
//     template: '<App/>'
// })
